import type { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { config } from './config';

const connectionString = config.appInsightsConnectionString;

let _ai: ApplicationInsights | null = null;

// Lazy-loaded so the SDK (~190KB raw / ~77KB gzip) is fetched after first paint,
// keeping the initial bundle under the 200KB performance budget per
// frontend-performance.md.
export async function initAppInsights(): Promise<ApplicationInsights | null> {
  if (_ai) return _ai;
  if (!connectionString) return null;

  const { ApplicationInsights } = await import('@microsoft/applicationinsights-web');
  _ai = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: true,
      autoTrackPageVisitTime: true,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      enableUnhandledPromiseRejectionTracking: true,
      disableFetchTracking: false,
    },
  });

  _ai.loadAppInsights();
  _ai.addTelemetryInitializer((envelope) => {
    if (envelope.tags) envelope.tags['ai.cloud.role'] = 'admin-portal';
    if (envelope.data?.baseData) envelope.data.baseData.properties = {
      ...envelope.data.baseData.properties,
      portal: 'admin',
    };
  });
  _ai.trackPageView();

  return _ai;
}

export function getAppInsights(): ApplicationInsights | null {
  return _ai;
}
